import React from 'react';
import Typography from '@mui/material/Typography';
import type { SxProps, Theme } from '@mui/material/styles';

export default function SectionTitle({
  children,
  sx = {},
}: {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}) {
  return (
    <Typography
      variant="subtitle1"
      fontWeight="bold"
      sx={{
        mb: 1.5,
        textAlign: 'left',
        fontSize: '1.05rem',
        letterSpacing: '0.01em',
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
}
